<template>
  <div>
    <provider-details-header :provider="provider" :is-excluded="isExcludedProvider" />

    <div v-if="isLoggedIn && isPremium && !isExcludedProvider" class="mt-2">
      <p v-if="enquiries.loading">
        <b-spinner small variant="primary" /> Loading enquiries...
      </p>
      <p v-else>
        You have made <strong>{{ enquiries.data.length }}</strong> enquir{{ enquiries.data.length === 1 ? 'y' : 'ies' }} to <strong>{{ provider.data.providerName }}</strong>.
        <router-link :to="{ name: 'your-enquiries' }">Click here to view and manage your enquiries.</router-link>
      </p>
    </div>

    <div v-else-if="!isExcludedProvider" class="mt-2">
      <p v-if="enquiries.loading">
        <b-spinner small variant="primary" /> Loading enquiries...
      </p>
      <p v-else>
        You have made <strong>{{ enquiries.data.length }}</strong> enquir{{ enquiries.data.length === 1 ? 'y' : 'ies' }} to <strong>{{ provider.data.providerName }}</strong>.
        <span
          id="provider-enquiries-lock"
          class="enquiries-link-disabled text-primary d-inline-block"
          role="link"
          aria-disabled="true"
          tabindex="0"
        >
          Click here to view and manage your enquiries.
          <feather-icon
            icon="LockIcon"
            size="14"
            class="ml-50 text-muted"
          />
        </span>
        <b-tooltip
          target="provider-enquiries-lock"
          triggers="hover focus"
          placement="top"
        >
          Upgrade to Premium to use this feature
        </b-tooltip>
      </p>
    </div>

    <br>

    <category-product-data
      v-if="$route.params.pid && provider.data.providerName"
      category="provider"
      :category-id="String($route.params.pid)"
      filter-key="providers"
      :filter-value="String(provider.data.providerName)"
    />

  </div>
</template>
<script>
import {
  BSpinner, BTooltip,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import ProviderDetailsHeader from './ProviderDetailsHeader.vue'
import CategoryProductData from '../CategoryProductData.vue'

export default {
  components: {
    BSpinner,
    BTooltip,
    ProviderDetailsHeader,
    CategoryProductData,
  },
  data() {
    return {
      provider: {
        data: {},
        loading: false,
        error: false,
      },
      isExcludedProvider: false,
      enquiries: {
        data: [],
        loading: false,
        error: false,
      },
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn',
      'isPremium',
    ]),
  },
  watch: {
    isLoggedIn(newVal) {
      if (newVal) {
        this.getProviderEnquiry()
      }
    },
  },
  created() {
    this.loadProvider()
    this.checkIfExcludedProvider()
    if (this.isLoggedIn) {
      this.getProviderEnquiry()
    }
  },
  methods: {
    checkIfExcludedProvider() {
      if (!this.$route.params.pid) return

      this.$http
        .get('public.cfc?method=getCategorySummary&category=provider')
        .then(response => {
          const providerId = Number(this.$route.params.pid)
          const excludedContent = response.data.EXCLUDEDCONTENT || []
          this.isExcludedProvider = excludedContent.some(p => p.id === providerId)
        })
        .catch(error => {
          console.error('Error checking excluded provider status:', error)
        })
    },
    loadProvider() {
      if (!this.$route.params.pid) return

      this.provider.loading = true
      this.provider.error = false

      this.$http.get(`public.cfc?method=getProviderContact&providerId=${this.$route.params.pid}`)
        .then(response => {
          this.provider.data = response.data
        })
        .catch(error => {
          this.provider.error = error
        })
        .finally(() => {
          this.provider.loading = false
        })
    },
    getProviderEnquiry() {
      if (!this.$route.params.pid) return

      this.enquiries.loading = true
      this.enquiries.error = false

      this.$http.get('research.cfc', {
        params: {
          method: 'getProviderEnquiry',
          providerId: this.$route.params.pid,
        },
      })
        .then(response => {
          console.log('Provider Enquiry:', response.data)
          if (response.data.success && response.data.enquiries) {
            this.enquiries.data = response.data.enquiries
          }
        })
        .catch(error => {
          console.error('Error loading provider enquiry:', error)
          this.enquiries.error = true
        })
        .finally(() => {
          this.enquiries.loading = false
        })
    },
  },
}
</script>

<style scoped>
.enquiries-link-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
